/*
 * @Author: 李明明
 * @Date: 2022-07-28 09:33:50
 * @LastEditTime: 2023-12-21 09:17:39
 * @LastEditors: 李明明
 * @Description: 
 * @FilePath: /ykt-micro-main/src/main.js
 * 代码版权方：'政府采购信息网'
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import start from '@/micros'
import 'normalize.css/normalize.css'
import installElementPlus from './plugins/element'
import { checkAndRefreshIfOutdated } from 'version-manager-sdk/runtime'
// 根据不同环境使用不同的版本文件路径
const versionJsonPath = process.env.NODE_ENV === 'production' ? './version.json' : './version.test.json';
// checkAndRefreshIfOutdated({
//     versionJsonPath: versionJsonPath
// })

import '@/assets/scss/index.scss'
// 引入axios封装
import axios from '@/utils/axios';
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  next();
})
const app = createApp(App)
installElementPlus(app)
app.config.globalProperties.$axios = axios;
app.use(store).use(router).mount('#app')

app.config.warnHandler = () => null;
start({ 
  sandbox: { experimentalStyleIsolation: true},
  prefetch: false
})
